import Draft from "draft-js";
import {
  inlineLinkDecorator,
  richLinkDecorator,
} from "@sonder/editor/source/core/components/Link";
import { mentionDecorator } from "@sonder/editor/source/core/components/Mention/Mention.decorator";
import { searchTermDecorator } from "@sonder/editor/source/core/components/SearchTerm/SearchTerm.decorator";
import { ENABLE_INCOMPLETE_FEATURES } from "@sonder/editor/source/core/constants";
import { getStateFromHtml } from "@sonder/editor/source/core/helpers/getStateFromHtml";
import { EditorProps } from "@sonder/editor/typings/editor";

export const getInitialEditorState = ({
  htmlBody,
  plainBody,
}: Partial<EditorProps>): Draft.EditorState => {
  const body = htmlBody || plainBody || "";
  const editorState = Draft.EditorState.createWithContent(
    getStateFromHtml(body),
  );

  const decorators = [
    inlineLinkDecorator,
    mentionDecorator,
    searchTermDecorator,
  ];
  if (ENABLE_INCOMPLETE_FEATURES) decorators.push(richLinkDecorator);

  return Draft.EditorState.set(editorState, {
    decorator: new Draft.CompositeDecorator(decorators),
  });
};
